"use client";

import { useTranslations } from "next-intl";

import { Journals } from "@/components/expense/fields/Journals";
import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { RadioGroup } from "@/components/ui/radio-group";

interface IJournalSelectorProps {
    isPending: boolean;
    value: string | undefined;
    onChange: (journal: string | undefined) => void;
}

export const JournalSelector = ({ value, onChange, isPending }: IJournalSelectorProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("compte")} :</FormLabel>
            <div className="w-full md:w-1/2">
                <FormControl>
                    <RadioGroup
                        onValueChange={ onChange }
                        defaultValue={ value }
                        className="flex flex-wrap"
                    >
                        <Journals value={ value } isPending={ isPending } />
                    </RadioGroup>
                </FormControl>
                <FormMessage className="mt-2" />
            </div>
        </FormItem>
    );
};